import { render, staticRenderFns } from "./CertificateDetailPage.vue?vue&type=template&id=1e19f4c7"
import script from "./CertificateDetailPage.vue?vue&type=script&lang=js"
export * from "./CertificateDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports